import React, { useState, useEffect, useMemo } from 'react';

import IconWithText from 'components/Widgets/IconWithText';

import Preview from 'components/new_ui/Ratings/Preview';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { Button } from 'react-bootstrap5';
import EmptyFeedback from 'images/new_ui/members/member-feedback-empty.svg';
import Actions from '../Actions';

export default function Feedbacks() {
  const [isLoading, setIsLoading] = useState(true);
  const [isPossibleMoreLoad, setIsPossibleMoreLoad] = useState(true);
  const [feedbacks, setFeedbacks] = useState(null);
  const [lastId, setLastId] = useState(null);

  const onLoadMore = () => {
    setIsLoading(true);
    Actions.loadFeedbacks(lastId, (data) => {
      setFeedbacks((prev) => [
        ...(prev || []),
        ...(data.length === 6 ? data.slice(0, -1) : data),
      ]);
      if (data && data.length > 0) {
        setLastId(data[data.length - 1].id);
      }
      if (data.length < 6) {
        setIsPossibleMoreLoad(false);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (feedbacks === null) {
      onLoadMore();
    }
  }, []);

  const groupFeedbacks = useMemo(() => {
    if (feedbacks === null) {
      return {};
    }

    return feedbacks.reduce((acc, obj) => {
      const coachingPlanId = obj.attributes.coaching_plan_id;
      if (!acc[coachingPlanId]) {
        acc[coachingPlanId] = [];
      }
      acc[coachingPlanId].push(obj);
      return acc;
    }, {});
  }, [feedbacks]);

  return (
    <>
      <h3>Ratings & Feedback</h3>
      <p>
        Your feedback is valuable!
        Let us know how your coaching experience has been and help us make it even better.
      </p>

      {feedbacks === null && <LoadingPlaceholder text="Loading..." />}

      {feedbacks && feedbacks.length === 0 && <img src={EmptyFeedback} alt="Feedback" />}

      {Object.keys(groupFeedbacks).map((key) => (
        <div className="mt-4" key={`feedback-program-${key}`}>
          <h5>{groupFeedbacks[key][0].attributes.coaching_plan}</h5>

          {groupFeedbacks[key].map((item) => (
            <IconWithText
              key={`feedback-item-${item.id}`}
              wrapperClassName="rating"
              iconClassName={`
                ${item.attributes.feedback_type === 'program'
                ? 'big-icon certified-icon icon-bg bg-secondary-1000' : 'big-icon picture-icon rounded-circle'} 
                    `}
              contentClassName="w-100"
              iconStyle={
                item.attributes.feedback_type === 'coach'
                  ? { backgroundImage: `url("${item.attributes.coach.avatar_url}")` }
                  : {}
}
            >
              <div className="d-flex justify-content-between">
                <h5>{item.attributes.feedback_type === 'coach' ? item.attributes.coach.full_name : 'Program'}</h5>
                <Preview
                  rate={item.attributes.rate}
                />
              </div>
              <p>{item.attributes.feedback.answer}</p>
              <p className="text-gray-700">October 26, 2022</p>
            </IconWithText>
          ))}

        </div>
      ))}

      {isPossibleMoreLoad && (
      <div className="text-center mt-4">
        <Button
          variant="outline-primary"
          className="btn-reverse"
          disabled={isLoading}
          onClick={onLoadMore}
        >
          Show More
        </Button>
      </div>
      )}

    </>
  );
}
